//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React, { useEffect, useState } from 'react';
import useZoom from './useZoom';

const withZoom = <P extends object>(
  Component: React.ComponentType<P>,
  threshold = 300,
) => {
  const WrappedComponent = (props: P) => {
    const isZoomedIn = useZoom(threshold);

    // Transition logic for zoom handling
    const [showTransition, setShowTransition] = useState(false);
    useEffect(() => {
      if (isZoomedIn) {
        setShowTransition(true);
        const timer = setTimeout(() => setShowTransition(false), 300); // 300ms transition
        return () => clearTimeout(timer);
      }
    }, [isZoomedIn]);

    return (
      <>
        <Component
          {...(props as any)}
          isZoomedIn={isZoomedIn}
          showZoomTransition={showTransition}
        />
      </>
    );
  };

  WrappedComponent.displayName = `withZoom(${Component.displayName || Component.name || 'Component'})`;

  return WrappedComponent;
};

export default withZoom;
